import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const findServiceList = createAsyncThunk('findService/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'find_services',
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                search: data?.search,
                premise_id: data?.premise_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const findServiceDetails = createAsyncThunk('findService/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `find_services/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addFindService = createAsyncThunk('findService/add', async (data) => {
    const bodyFormData = new FormData()
    bodyFormData.append('premise_id', data?.values?.premise_id ?? '')
    bodyFormData.append('service_category', data?.values?.service_category ?? '')
    bodyFormData.append('service_name', data?.values?.service_name ?? '')
    bodyFormData.append('service_mobile', data?.values?.mobile_number ?? '')
    bodyFormData.append('service_alternative_mobile', data?.values?.alternative_contact ?? '')
    bodyFormData.append('service_email', data?.values?.email ?? '')
    bodyFormData.append('description', data?.values?.description ?? '')
    bodyFormData.append('service_address', data?.values?.address ?? '')
    bodyFormData.append('status', data?.values?.status ?? 'Active')
    if (data?.values?.photo) {
        bodyFormData.append('service_profile', data.values.photo)
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'find_services',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", type: 'find_services', Authorization: SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const updateFindService = createAsyncThunk('findService/update', async (data) => {
    const bodyFormData = new FormData()
    bodyFormData.append('find_services_id', data?.values?.id)
    bodyFormData.append('premise_id', data?.values?.premise_id ?? '')
    bodyFormData.append('service_category', data?.values?.service_category ?? '')
    bodyFormData.append('service_name', data?.values?.service_name ?? '')
    bodyFormData.append('service_mobile', data?.values?.mobile_number ?? '')
    bodyFormData.append('service_alternative_mobile', data?.values?.alternative_contact ?? '')
    bodyFormData.append('service_email', data?.values?.email ?? '')
    bodyFormData.append('description', data?.values?.description ?? '')
    bodyFormData.append('service_address', data?.values?.address ?? '')
    bodyFormData.append('status', data?.values?.status ?? 'Active')
    if (data?.values?.photo) {
        bodyFormData.append('service_profile', data.values.photo)
    }

    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'update_find_services',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", type: 'find_services', Authorization: SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delFindService = createAsyncThunk('findService/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `find_services/${data?.id}`,
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie('user_token') }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const findService = createSlice({
    name: 'findService',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(findServiceList.pending, (state) => {
            state.loading = true
        })
        builder.addCase(findServiceList.fulfilled, (state, action) => {
            state.loading = false
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        })
        builder.addCase(findServiceList.rejected, (state) => {
            state.loading = false
        })

        builder.addCase(findServiceDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        })
    },
})

export default findService.reducer;